import { UuidProjectType } from 'core/userContext';
import { UniqueIdentifierValues } from './types';

export const SANDBOX = 'Sandbox';
export const NORMAL = 'Normal';
export const ARCHIVE_TEXT = 'ARCHIVE';

export const NAME = 'name';
export const TIME_ZONE = 'timeZone';
export const UNIQUE_IDENTIFIER = 'uniqueIdentifier';
export const SHARD_COUNT = 'shardCount';

export const uuidProjectTypeByUniqueIdentifier = {
  [UniqueIdentifierValues.userId]: UuidProjectType.EmailNonUnique,
  [UniqueIdentifierValues.emailOrUserId]: UuidProjectType.EmailUnique,
};
